module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921070834_T.2609fc96.jpg";